import _defineProperty from "/Users/nvenkat/Desktop/GitRepos/vitalize-web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { mode, cssVar } from "@chakra-ui/theme-tools";
var $bg = cssVar("tooltip-bg");
var $arrowBg = cssVar("popper-arrow-bg");

var baseStyle = function baseStyle(props) {
  var _ref;

  var bg = mode("gray.700", "gray.300")(props);
  return _ref = {}, _defineProperty(_ref, $bg.variable, "colors." + bg), _defineProperty(_ref, "px", "8px"), _defineProperty(_ref, "py", "2px"), _defineProperty(_ref, "bg", [$bg.reference]), _defineProperty(_ref, $arrowBg.variable, [$bg.reference]), _defineProperty(_ref, "color", mode("whiteAlpha.900", "gray.900")(props)), _defineProperty(_ref, "borderRadius", "sm"), _defineProperty(_ref, "fontWeight", "medium"), _defineProperty(_ref, "fontSize", "sm"), _defineProperty(_ref, "boxShadow", "md"), _defineProperty(_ref, "maxW", "320px"), _defineProperty(_ref, "zIndex", "tooltip"), _ref;
};

export default {
  baseStyle: baseStyle
};